import { LocaleStrings, LocaleKey } from './keys';
import en from './languages/en';
import zh from './languages/zh';
import hi from './languages/hi';
import es from './languages/es';
import fr from './languages/fr';
import ar from './languages/ar';
import bn from './languages/bn';
import pt from './languages/pt';
import ru from './languages/ru';
import ur from './languages/ur';
import id from './languages/id';
import de from './languages/de';
import ja from './languages/ja';
import sw from './languages/sw';
import mr from './languages/mr';
import vi from './languages/vi';
import th from './languages/th';
import ko from './languages/ko';

/**
 * Map of language code → locale strings.
 * Falls back to English for any unsupported language.
 */
const locales: Record<string, LocaleStrings> = {
  en, zh, hi, es, fr, ar, bn, pt, ru, ur, id, de, ja, sw, mr, vi, th, ko,
};

/**
 * Get the full locale strings object for a language code.
 */
export function getLocaleStrings(languageCode: string): LocaleStrings {
  return locales[languageCode] || en;
}

/**
 * Get a single localized string by key, with optional interpolation.
 * Placeholders use {name} syntax, e.g. "Showing {visible} of {total} games".
 */
export function t(
  strings: LocaleStrings,
  key: LocaleKey,
  params?: Record<string, string | number>
): string {
  let value = strings[key] || en[key] || key;
  if (params) {
    Object.entries(params).forEach(([paramKey, paramValue]) => {
      value = value.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(paramValue));
    });
  }
  return value;
}

export type { LocaleStrings, LocaleKey };
